import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Icon, IconTypes } from '@eika/icon';

import { WispSignal } from '../../components/WispSignal';
import { useAgreement } from '../../fetchHooks/useProfile';

import './CorporateHeaderApp.scss';

const DesktopHeaderIkon: React.FC = () => {
    const { data: agreement, isLoading } = useAgreement();

    return (
        <>
            <div className="corporate-header__wisp-signal">
                <WispSignal />
            </div>
            <div className="corporate-header__profile-button">
                <Icon type={IconTypes.BEDRIFT_24} />
                <span className="corporate-header__profile-name-wrapper">
                    {isLoading ? (
                        <Skeleton height={20} width={120} className="corporate-header__profile-name-skeleton" />
                    ) : (
                        <span className="corporate-header__profile-name">{agreement?.agreementName}</span>
                    )}
                </span>
            </div>
        </>
    );
};

export default DesktopHeaderIkon;
